import React from 'react';
import { Cards } from 'phosphor-react';

const DrillVocabButton = ({ level, completed, total, onStart, loading = false }) => {
  const isLoading = level === null || completed === null || loading;
  const progressPercentage = isLoading ? 0 : (total ? Math.min(100, Math.max(0, (completed / total) * 100)) : 0);
  const progressValue = Math.round(progressPercentage);
  const displayLevel = isLoading ? null : (level || 0);
  const levelDigits = String(displayLevel ?? '').length;
  const levelFontSize = levelDigits >= 3 ? '20px' : levelDigits === 2 ? '22px' : '28px';

  return (
    <div className="drill-vocab-overall-card bg-gradient-to-br from-[#4a6fa5] via-[#345d8a] to-[#1e3d6f] dark:from-[#2e4a6e] dark:via-[#253d5e] dark:to-[#1c3050] rounded-[10px] px-[10px] py-[6px] text-white w-full flex-shrink-0 flex flex-col gap-1 self-stretch relative overflow-hidden min-h-[160px] h-full min-w-0 border border-[rgba(160,205,255,0.25)] dark:border-[rgba(160,205,255,0.3)] max-md:rounded-xl max-md:p-[10px_12px] max-md:shadow-[0_2px_8px_rgba(0,0,0,0.08)] max-md:min-h-0 max-md:h-auto">
      <div className="card-header flex items-center justify-between -mb-[3px]">
        <div className="flex items-center gap-1.5">
          <Cards size={14} weight="fill" />
          <span className="card-title text-[11px] font-semibold">Drill Vocab</span>
        </div>
      </div>
      <div className="card-body flex flex-col gap-1 flex-1 max-md:flex-row max-md:flex-wrap max-md:items-start">
        <div className="card-level-section flex flex-col gap-0.5 max-md:min-w-[50px]">
          <span className="card-level-label text-[10px] font-semibold text-[rgba(255,255,255,0.8)] tracking-[0.4px] uppercase">Level</span>
          <div className="card-level-row flex items-baseline">
            <div className="card-level-wrapper flex items-baseline gap-0.5 w-full">
              {isLoading ? (
                <div className="card-level-number text-2xl font-bold leading-none animate-blink">--</div>
              ) : (
                <div className="card-level-number font-bold leading-none" style={{ fontSize: levelFontSize }}>{displayLevel}</div>
              )}
              <span className="card-level-slash text-[11px] text-[rgba(255,255,255,0.4)] font-normal">/100</span>
            </div>
          </div>
        </div>
        <div className="card-progress-section flex flex-col gap-[3px] flex-1">
          <span className="card-progress-label text-[11px] font-semibold text-[rgba(255,255,255,0.8)]">Progress</span>
          {isLoading ? (
            <>
              <div className="card-progress-row flex items-center gap-[3px]">
                <div className="card-progress-bar flex-1 h-[6px] bg-[rgba(255,255,255,0.2)] dark:bg-[rgba(255,255,255,0.12)] rounded-full overflow-hidden relative">
                  <div className="card-progress-fill h-full bg-gradient-to-r from-[#fcb319] to-[#f5a500] rounded-full transition-[width] duration-300 ease-out animate-blink" style={{ width: '0%' }}></div>
                </div>
              </div>
              <span className="card-progress-count text-[12px] font-light text-[rgba(255,255,255,0.7)] text-left animate-blink">--% ke level selanjutnya</span>
            </>
          ) : (
            <>
              <div className="card-progress-row flex items-center gap-[3px]">
                <div className="card-progress-bar flex-1 h-[6px] bg-[rgba(255,255,255,0.2)] dark:bg-[rgba(255,255,255,0.12)] rounded-full overflow-hidden relative">
                  <div className="card-progress-fill h-full bg-gradient-to-r from-[#fcb319] to-[#f5a500] rounded-full transition-[width] duration-300 ease-out relative overflow-hidden" style={{ width: `${progressPercentage}%` }}>
                    <div className="absolute inset-0 rounded-full bg-gradient-to-r from-transparent via-white/40 to-transparent animate-shimmer" aria-hidden />
                    <div className="absolute top-0 left-0 w-[30%] h-full rounded-full bg-gradient-to-r from-white/30 to-transparent animate-shine" aria-hidden />
                  </div>
                </div>
              </div>
              <span className="card-progress-count text-[12px] font-light text-[rgba(255,255,255,0.7)] text-left">{progressValue}% ke level selanjutnya</span>
            </>
          )}
        </div>
        <button
          className="practice-start-button mt-auto px-5 py-2 bg-gradient-to-br from-[#fcb319] to-[#f5a500] text-[#1d4746] border-none rounded-xl text-[13px] font-semibold cursor-pointer transition-all duration-300 shadow-[0_2px_4px_rgba(252,179,25,0.2)] relative overflow-hidden whitespace-nowrap hover:from-[#f5a500] hover:to-[#e69500] hover:shadow-[0_4px_8px_rgba(252,179,25,0.3)] hover:-translate-y-px active:translate-y-0 active:scale-[0.98] active:shadow-[0_1px_2px_rgba(252,179,25,0.2)] before:content-[''] before:absolute before:top-0 before:left-[-100%] before:w-full before:h-full before:bg-[linear-gradient(90deg,transparent,rgba(255,255,255,0.3),transparent)] before:transition-[left] before:duration-500 hover:before:left-full max-md:hidden"
          onClick={onStart}
        >
          Start
        </button>
      </div>
      <button
        className="practice-start-button mt-auto px-5 py-2 bg-gradient-to-br from-[#fcb319] to-[#f5a500] text-[#1d4746] border-none rounded-xl text-[13px] font-semibold cursor-pointer transition-all duration-300 shadow-[0_2px_4px_rgba(252,179,25,0.2)] relative overflow-hidden whitespace-nowrap hover:from-[#f5a500] hover:to-[#e69500] hover:shadow-[0_4px_8px_rgba(252,179,25,0.3)] hover:-translate-y-px active:translate-y-0 active:scale-[0.98] active:shadow-[0_1px_2px_rgba(252,179,25,0.2)] before:content-[''] before:absolute before:top-0 before:left-[-100%] before:w-full before:h-full before:bg-[linear-gradient(90deg,transparent,rgba(255,255,255,0.3),transparent)] before:transition-[left] before:duration-500 hover:before:left-full hidden max-md:block w-full"
        onClick={onStart}
      >
        Start
      </button>
    </div>
  );
};

export default DrillVocabButton;
